<template>
  <div class="step-where pb-20 grid grid-cols-2 mdsm:grid-cols-1 gap-20 md:gap-10 sm:gap-6">
    <div>
      <wizard-header
        :on-back="onBack"
        :curr-step="currStep"
        title="Where would you like to go?"
        sub-title="Select up to two destinations or skip this step"
      />

      <div v-if="!loading && displayItems.length" class="grid grid-cols-3 sm:grid-cols-2 gap-4">
        <template v-for="item in displayItems">
          <wizard-item
            :key="item.value"
            :title="item.name"
            :score="item.score"
            :on-click="() => onChange(item)"
            :disabled="
                (selected.length === 2 &&
                !Boolean(selected.find(i => i.value === item.value)))
            "
            :active="Boolean(selected.find(i => i.value === item.value))"
          />
        </template>
      </div>

      <wizard-action
        :on-continue="onContinue"
        :disabledContinue="!selected.length"
        :on-skip="onSkip"
      />
    </div>
    <div class="h-full md:hidden sm:hidden">
      <img
        src="/img/wizard/step-where.png"
        alt="wizard-banner"
        class="object-contain h-full w-full"
      />
    </div>
  </div>
</template>

<script>
import WizardHeader from "../../components/Wizard/Header";
import WizardItem from "../../components/Wizard/Item";
import WizardAction from "../../components/Wizard/Action";

// import { countries } from "./items";
// import { destinationIndex } from "./algolia-client";

export default {
  name: "StepWhere",
  components: {
    WizardHeader,
    WizardItem,
    WizardAction
  },
  mounted() {
    this.init()
    this.getDestinations();
  },
  props: {
    currSelection: {
      type: Object,
      default: () => ({})
    },
    currStep: { type: Number, default: 3 },
    loading: { type: Boolean, default: true },
    items: {
      type: Array,
      default: () => ([])
    },
  },
  data() {
    return {
      selected: [],
      displayItems: []
      // destinationIndex: null
    };
  },
  methods: {
    init() {
      const currSelection = this.currSelection;
      const stepWhereData = currSelection["where"];
      this.selected =
        Boolean(stepWhereData) &&
        Array.isArray(stepWhereData) &&
        stepWhereData.length
          ? stepWhereData
          : [];
    },
      getDestinations() {
          this.$emit("loading", true);
          $.ajax({
              method: "POST",
              url: "/",
              data: {
                action: "zuBlu/wizard/getDestinations",
                [window.Craft.csrfTokenName]: window.Craft.csrfTokenValue,
                currSelection: this.currSelection
              },
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .done(res => {
              const destinations = JSON.parse(res)
              let displayItems = []

              for (let dest of destinations) {
                let matchDest = this.items.find(i => i.value === dest.country.toLowerCase())

                if (Boolean(matchDest)) {
                  let selectedDest = displayItems.find(i => i.value === dest.country.toLowerCase())

                  if (!Boolean(selectedDest)) {
                    const item = {
                      name: dest.country_title,
                      value: dest.country.toLowerCase(),
                      score: Number(dest.selected_species_visibilities_total)
                    }

                    displayItems = [
                      ...displayItems,
                      item
                    ]
                  }
                }
              }


              this.displayItems = displayItems.sort((a, b) => b.score - a.score)
              this.$emit("loading", false);
          })
          .fail(console.error)
      },
    onBack() {
      this.$emit("on-back", this.selected);
    },
    onContinue() {
      this.$emit("on-continue", this.selected);

      this.$emit("loading", true);
      const params = this.setParams();
      setTimeout(() => {
        // const params = new URLSearchParams(window.location.search)
        window.location.href = "/wizard-result?" + params;
      }, 1000)
    },
    onSkip() {
      this.onChange(false);
      this.$emit("on-skip", this.selected);

      this.$emit("loading", true);
      const params = this.setParams(true);
      setTimeout(() => {
        // const params = new URLSearchParams(window.location.search)
        window.location.href = "/wizard-result?" + params;
      }, 1000)
    },
    onChange(country) {
      if (!country) {
        this.selected = []
        return this.$emit("on-change", this.selected)
      }

      let currSelected = [].concat(this.selected);
      if (currSelected.find(i => i.value === country.value)) {
        currSelected = currSelected.filter(i => i.value !== country.value);
      } else {
        if (currSelected.length < 2) {
          currSelected = [country, ...currSelected];
        } else {
          currSelected = [
            country,
            ...currSelected.slice(0, currSelected.length - 1)
          ];
        }
      }

      this.selected = currSelected;

      this.$emit("on-change", this.selected);
    },
    setParams(skip = false) {
      const params = new URLSearchParams(window.location.search);
      const stepWhatData = this.currSelection["what"];

      if (Boolean(stepWhatData && stepWhatData.length)) {
        params.set("what", stepWhatData.map(s => s.value).join("+"))
      } else {
        params.delete("what")
      }

      const stepWhenData = this.currSelection["when"];
      if (Boolean(stepWhenData)) {
        params.set("when", stepWhenData)
      } else {
        params.delete("when")
      }

      if (!skip) {
        const stepWhereData = this.currSelection["where"];
        if (Boolean(stepWhereData && stepWhereData.length)) {
          params.set("where", stepWhereData.map(s => s.value).join("+"))
        } else {
          params.delete("where")
        }
      }

      // if (window.history && window.history.replaceState) {
      //   const pathname = window.location.pathname
      //
      //   history.replaceState(null, '', pathname + '?' + params.toString())
      // }

      return params.toString()
    },
  }
};
</script>
